class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    if (typeof gsap === 'undefined') {
      // Fallback to CSS if GSAP not available
      this.notification.classList.add('animate', 'active');
      this.notification.addEventListener(
        'transitionend',
        () => {
          this.notification.focus();
          trapFocus(this.notification);
        },
        { once: true }
      );
    } else {
      // Kill any existing animation
      if (this.notification._cartNotificationTimeline) {
        this.notification._cartNotificationTimeline.kill();
        this.notification._cartNotificationTimeline = null;
      }

      // Remove hidden class first
      this.notification.classList.remove('hidden');
      this.notification.classList.add('animate');
      
      // Clear any existing GSAP properties and CSS transitions
      gsap.killTweensOf(this.notification);
      gsap.set(this.notification, { clearProps: 'all' });
      
      // Set initial state synchronously before any rendering
      gsap.set(this.notification, {
        opacity: 0,
        y: -20,
        visibility: 'visible',
        immediateRender: true
      });

      // Start animation immediately
      const tl = gsap.timeline({
        onComplete: () => {
          this.notification.focus();
          trapFocus(this.notification);
          this.notification._cartNotificationTimeline = null;
        }
      });

      tl.to(this.notification, {
        opacity: 1,
        y: 0,
        duration: 0.6,
        ease: 'power2.out'
      });

      this.notification._cartNotificationTimeline = tl;
    }

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    if (typeof gsap === 'undefined') {
      // Fallback to CSS if GSAP not available
      this.notification.classList.remove('active');
    } else {
      // Kill any existing animation
      if (this.notification._cartNotificationTimeline) {
        this.notification._cartNotificationTimeline.kill();
        this.notification._cartNotificationTimeline = null;
      }

      // Animate out
      const tl = gsap.timeline({
        onComplete: () => {
          this.notification.classList.add('hidden');
          this.notification.classList.remove('animate', 'active');
          gsap.set(this.notification, {
            clearProps: 'all'
          });
          this.notification._cartNotificationTimeline = null;
        }
      });

      tl.to(this.notification, {
        opacity: 0,
        y: -20,
        duration: 0.4,
        ease: 'power2.in'
      });

      tl.set(this.notification, {
        visibility: 'hidden'
      }, '-=0.1');

      this.notification._cartNotificationTimeline = tl;
    }

    document.body.removeEventListener('click', this.onBodyClick);
    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    if (this.header) this.header.reveal();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
